export default "__VITE_ASSET__Fhg58Mj6__"